/**
 * 商取引機能用の日本語テキストカタログ
 * (`@gamecodex/world-ui` → `features/commerce`)。
 *
 * キーはこの機能の React コンポーネント内の `t('commerce.*')` 呼び出しと対応しています。
 * 値は i18n 整備時に抽出された日本語文字列です。
 */
export const commerceJa = {
  // DtrpgClaimPage.tsx
  'commerce.dtrpg.seoTitle': 'ライブラリを請求する',
  'commerce.dtrpg.seoDescription': 'DriveThruRPG ライブラリをインポートして、Grymwyrd PDF を請求してください。',
  'commerce.dtrpg.heading': 'ライブラリを請求する',
  'commerce.dtrpg.intro':
    'DriveThruRPG で Grymwyrd を購入した、またはキャンペーンを支援しましたか？購入メールでログインして、ライブラリをインポートしてコピーを請求してください。',
  'commerce.dtrpg.sendLinkError': 'ログインリンクを送信できませんでした。しばらく後にもう一度お試しください。',
  'commerce.dtrpg.checkInboxPrefix': 'メールボックスを確認してください',
  'commerce.dtrpg.checkInboxSuffix':
    'そのメールが Grymwyrd を支援または購入していれば、ログインリンクが届いています—それをクリックしてここに戻り、ライブラリを請求してください。',
  'commerce.dtrpg.linkAutoSignIn': 'リンクで自動的にログインします—パスワードは不要です。',
  'commerce.dtrpg.purchaseEmailLabel': 'ご購入・ご支援用メールアドレス',
  'commerce.dtrpg.sendingLink': 'リンク送信中…',
  'commerce.dtrpg.emailLinkCta': 'ログインリンクをメールで送信',
  'commerce.dtrpg.signedInAs': 'ログイン状態:',
  'commerce.dtrpg.signOut': 'ログアウト',
  'commerce.dtrpg.dtrpgEmailLabel': 'DriveThruRPG メールアドレス',
  'commerce.dtrpg.dtrpgEmailOptional': '(オプション—上記と異なる場合)',
  'commerce.dtrpg.dtrpgEmailHelp': 'このアドレスを使用して、ライブラリを付与する際に DriveThruRPG の購入と照合します。',
  'commerce.dtrpg.libraryHeading': 'あなたの Grymwyrd ライブラリ',
  'commerce.dtrpg.noTitles': 'インポート可能なタイトルはまだ設定されていません。',
  'commerce.dtrpg.claimNotInLibrary':
    'このタイトルはまだライブラリにありません。正しい購入メールアドレスを使用したことを確認してください。',
  'commerce.dtrpg.claimSessionExpired': 'セッションが期限切れになりました—もう一度ログインしてください。',
  'commerce.dtrpg.claimError': 'このタイトルは現在請求できません。もう一度お試しください。',
  'commerce.dtrpg.preparingCopy': 'コピーを準備中…',
  'commerce.dtrpg.download': 'ダウンロード',
  'commerce.dtrpg.preparing': '準備中…',
  'commerce.dtrpg.claiming': '請求中…',
  'commerce.dtrpg.claim': '請求する',

  // PaywallPrompt.tsx
  'commerce.paywall.checkoutFailed': 'チェックアウトを開くことができません。しばらく後にもう一度お試しください。',
  'commerce.paywall.signInToPurchase': 'この購入を完了するにはログインしてください。',
  'commerce.paywall.vaultSealed': '商人の金庫は現在閉鎖されています—しばらく後にもう一度お試しください。',
  'commerce.paywall.signInToUnlock': 'ログインして解放',
  'commerce.paywall.comingSoonTitle': 'この購入はもうじき利用可能になります',
  'commerce.paywall.priceComingSoon': '{price}—もうじき',
  'commerce.paywall.comingSoon': 'もうじき',
  'commerce.paywall.openingVault': '金庫を開いています…',
  'commerce.paywall.unlockPrice': '解放—{price}',
  'commerce.paywall.unlock': '解放',

  // MarketplacePage.tsx
  'commerce.marketplace.installSuccess': '「{name}」をテーブルにインストールしました。',
  'commerce.marketplace.installNotOwned': 'このパックはまだ所有していません—パック購入機能はもうじき利用可能になります。',
  'commerce.marketplace.installHostOnly': 'テーブルホストのみがパックをインストールできます。',
  'commerce.marketplace.installError': 'このパックをインストールできません。もう一度お試しください。',
  'commerce.marketplace.installed': 'インストール済み',
  'commerce.marketplace.installing': 'インストール中…',
  'commerce.marketplace.installOnTable': 'テーブルにインストール',
  'commerce.marketplace.seoTitle': 'マーケットプレイス—パック',
  'commerce.marketplace.seoDescription':
    'クリエイター製コンテンツパック（マップ、シーン、ハンドアウト、プリセット）を閲覧してテーブルにインストールしてください。',
  'commerce.marketplace.eyebrow': 'マーケットプレイス',
  'commerce.marketplace.heading': 'コンテンツパック',
  'commerce.marketplace.intro':
    'マップ、シーン、ハンドアウト、クイックスタートプリセット—ワンクリックでテーブルにインストールしてください。',
  'commerce.marketplace.installingOnto': 'テーブル {tableId} にインストール中。',
  'commerce.marketplace.signInHeading': 'ログインしてパックを表示',
  'commerce.marketplace.signInBlurb': 'パックカタログはクリエイターアカウントに紐付けられています。',
  'commerce.marketplace.signIn': 'ログイン',
  'commerce.marketplace.loading': 'パックを呼び出し中…',
  'commerce.marketplace.noPacksHeading': 'パックなし',
  'commerce.marketplace.noPacksBlurb':
    'まだパックを公開していません。他のクリエイターのパックを閲覧できるパブリックマーケットプレイスはもうじき利用可能になります。',
  'commerce.marketplace.footer': '他のクリエイターのパックと有料パックはもうじき利用可能になります。',

  // SubscriberPerksPage.tsx
  'commerce.subscriber.perk1Title': '購読者専用テーブル',
  'commerce.subscriber.perk1Blurb': 'お気に入りのホストが購読者向けに予約しているテーブルに参加してください。',
  'commerce.subscriber.perk2Title': 'エクスクルーシブコンテンツ',
  'commerce.subscriber.perk2Blurb': 'キャンペーンのチャプター、シーン、ハンドアウトを他の誰よりも先に入手してください。',
  'commerce.subscriber.perk3Title': '購読者フレア',
  'commerce.subscriber.perk3Blurb': 'プロフィールおよびテーブルでの地位の印です。',
  'commerce.subscriber.seoTitle': '購読者特典',
  'commerce.subscriber.seoDescription':
    '購読者になると、専用テーブル、エクスクルーシブコンテンツ、購読者フレアが利用できます。',
  'commerce.subscriber.heading': '購読者になる',
  'commerce.subscriber.intro':
    'あなたが好きなホストやクリエイターを支援してください—彼らが内部サークルのために予約している特典を解放してください。',
  'commerce.subscriber.activeHeading': 'あなたは購読者です',
  'commerce.subscriber.activeBlurb':
    'あなたの特典はアクティブです。参加できる購読者テーブルで購読者紋章を探してください。',
  'commerce.subscriber.findTable': '購読者テーブルを探す',
  'commerce.subscriber.paywallTitle': 'Grymwyrd 購読者',
  'commerce.subscriber.paywallBlurb':
    '購読者専用テーブル、エクスクルーシブコンテンツ、購読者フレアを解放してください。',
  'commerce.subscriber.paywallPrice': '月額 $5 から',

  // TicketCheckoutPage.tsx
  'commerce.ticket.checkoutFailed': 'チェックアウトを開くことができません。しばらく後にもう一度お試しください。',
  'commerce.ticket.signInToBuy': 'このテーブルの座席を購入するにはログインしてください。',
  'commerce.ticket.boxOfficeClosed': 'チケット販売窓口は現在閉鎖されています—しばらく後にもう一度お試しください。',
  'commerce.ticket.seoTitle': '座席を購入',
  'commerce.ticket.seoDescription': 'チケット制テーブルの座席を予約してください。',
  'commerce.ticket.eyebrow': 'チケット制テーブル',
  'commerce.ticket.heading': '座席を予約',
  'commerce.ticket.loading': 'テーブルを読み込み中…',
  'commerce.ticket.notFoundHeading': 'テーブルが見つかりません',
  'commerce.ticket.notFoundBlurb': 'このテーブルは閉鎖された、またはドアが開かれたことがないかもしれません。',
  'commerce.ticket.backToLobby': 'ロビーに戻る',
  'commerce.ticket.freeHeading': 'このテーブルは無料で参加できます',
  'commerce.ticket.freeBlurb': 'チケットは不要です—椅子を引いてください。',
  'commerce.ticket.goToLobby': 'ロビーへ',
  'commerce.ticket.untitledTable': 'タイトルなしテーブル',
  'commerce.ticket.seatPrice': '座席価格',
  'commerce.ticket.spectatorsNote': '観客もこのテーブルのチケットを保持する必要があります。',
  'commerce.ticket.paymentReceived': '支払いが受け取られました—座席は予約されています。ロビーに行ってそこに着席してください。',
  'commerce.ticket.signInToBuySeat': 'ログインして座席を購入',
  'commerce.ticket.openingBoxOffice': 'チケット販売窓口を開いています…',
  'commerce.ticket.buySeatPrice': '座席を購入—{price}',
  'commerce.ticket.comingSoonTitle': 'チケット販売はもうじき開始',
  'commerce.ticket.ticketingComingSoon': 'チケット販売もうじき',
  'commerce.ticket.comingSoonFooter': '有料座席はもうじく準備できます。今のところはホストに無料招待を求めてください。',

  // TipGoalManagerPage.tsx
  'commerce.tip.errHostOnlyGoal': 'テーブルホストのみがゴールを管理できます。',
  'commerce.tip.errHostOnlyBounty': 'テーブルホストのみが懸賞金を管理できます。',
  'commerce.tip.errMaxGoal': 'このテーブルのゴール数が上限に達しました。',
  'commerce.tip.errMaxBounty': 'このテーブルの懸賞金数が上限に達しました。',
  'commerce.tip.errMissingGoal': 'そのゴールは必要な詳細が不足しています。',
  'commerce.tip.errMissingBounty': 'その懸賞金は必要な詳細が不足しています。',
  'commerce.tip.errSignIn': 'このテーブルを管理するにはホストとしてログインしてください。',
  'commerce.tip.errSaveFailedGoal': 'ゴールを保存できませんでした。もう一度お試しください。',
  'commerce.tip.errSaveFailedBounty': '懸賞金を保存できませんでした。もう一度お試しください。',
  'commerce.tip.goalValidation': 'ラベルと正の金額目標を追加してください。',
  'commerce.tip.goalAdded': 'ゴール「{label}」が追加されました。',
  'commerce.tip.goalLabelPlaceholder': 'ゴールラベル（例：ボスを召喚）',
  'commerce.tip.targetPlaceholder': '目標 $',
  'commerce.tip.cuePlaceholder': '達成時のキュー（例：ファンファーレ）',
  'commerce.tip.addGoal': 'ゴールを追加',
  'commerce.tip.bountyValidation': 'ラベル、正の目標、トリガーを追加してください。',
  'commerce.tip.bountyAdded': '懸賞金「{label}」が追加されました。',
  'commerce.tip.bountyLabelPlaceholder': '懸賞金ラベル（例：ナチュラル 20 がパーティを救う）',
  'commerce.tip.triggerPlaceholder': 'トリガー（例：ナチュラル 20）',
  'commerce.tip.addBounty': '懸賞金を追加',
  'commerce.tip.signInToManage': 'このテーブルを管理するにはログインしてください。',
  'commerce.tip.bountyClaimed': '懸賞金「{label}」が請求されました。',
  'commerce.tip.seoTitle': 'チップゴール・懸賞金',
  'commerce.tip.seoDescription': 'テーブルのチップゴールと懸賞金を設定してください。',
  'commerce.tip.backToLobby': 'ロビーに戻る',
  'commerce.tip.heading': 'チップゴール・懸賞金',
  'commerce.tip.intro':
    'テーブルのゴールと懸賞金を設定してください。チップが集まると、キューが視聴者向けに発動します。配信表示はあなたの放送オーバーレイで処理されます。',
  'commerce.tip.loading': '台帳を読み込み中…',
  'commerce.tip.loadErrorTitle': '台帳を読み込めません',
  'commerce.tip.raisedSoFar': 'これまでに集められた金額:',
  'commerce.tip.tipGoalsHeading': 'チップゴール',
  'commerce.tip.noGoals': 'ゴールはまだありません—下記から最初のゴールを追加してください。',
  'commerce.tip.reachedAria': '達成',
  'commerce.tip.bountiesHeading': '懸賞金',
  'commerce.tip.noBounties': '懸賞金はまだありません—下記から最初の懸賞金を追加してください。',
  'commerce.tip.whenLabel': '・トリガー: {trigger}',
  'commerce.tip.claimed': '請求済み',
  'commerce.tip.claimTitleReady': 'この懸賞金を請求済みにする',
  'commerce.tip.claimTitleNotFunded': 'まだ資金化されていません',
  'commerce.tip.claim': '請求',
} as const
